import * as React from "react";
const SVGComponent = ({ strokeColor = "#90EE90", ...props }) => (
  <svg
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="100%"
    height="100%"
    x="0px"
    y="0px"
    viewBox="0 0 60.4 95.3"
    style={{
      enableBackground: "new 0 0 60.4 95.3",
    }}
    xmlSpace="preserve"
    {...props}
  >
    <style type="text/css">
      {
        `\n\t.srfront_st0{fill:none;stroke:${strokeColor};stroke-width:0.679;stroke-linecap:round;stroke-linejoin:round;}\n\t.srfront_st1{fill:${strokeColor};stroke:${strokeColor};stroke-width:0.679;stroke-linecap:round;stroke-linejoin:round;}\n\t.srfront_st2{fill:none;stroke:${strokeColor};stroke-width:0.679;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4.0016;}\n\t.srfront_st3{fill:none;stroke:${strokeColor};stroke-width:0.679;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4.0014;}\n`
      }
    </style>
    <g id="Layer_2_00000096754795704138239950000009198641046438642357_">
      <g id="Layer_1_00000172431740290962118360000015549662040293192599_">
        <g id="Layer_1_00000176015738785268899610000008737900945278076292_">
          <g id="Layer_1_00000131364332075015321670000002665866631553461418_">
            <g>
              <path className="srfront_st0" d="M45.6,1.2c-4.1,5.9-8.9,38.4-11.7,46.6c0,0,0.1,22.4,0,22.9c0-0.1,0.9,16.8,0.7,19.6" />
              <path className="srfront_st0" d="M38.1,94.4L20.9,73.5c-0.7-10.1-7-24.9-10.3-28.4l1.5-7.9" />
              <path className="srfront_st0" d="M12.1,37.2c2.3-14.3,3.8-33.9,8.5-34.6" />
            </g>
          </g>
          <path className="srfront_st0" d="M14.4,22.9l41.4,27.4" />
        </g>
      </g>
      <g id="Layer_2_00000035516422123843372410000014161462676458171016_">
        <circle className="srfront_st1" cx="40.5" cy="61.3" r="0.5" />
        <path className="srfront_st0" d="M43.9,64.4L39.7,62c-0.2-0.2-0.4-0.5-0.2-0.7l0.5-0.7c0.2-0.2,0.5-0.4,0.7-0.2l4.1,2.4 c0.2,0.2,0.4,0.5,0.2,0.7l-0.5,0.7C44.4,64.5,44.2,64.5,43.9,64.4z" />
        <line className="srfront_st0" x1="41.7" y1="60.9" x2="40.7" y2="62.5" />
        <path className="srfront_st0" d="M17.1,41.2L13,38.9c-0.2-0.2-0.4-0.5-0.2-0.7l0.4-0.7c0.2-0.2,0.5-0.4,0.7-0.2l4.1,2.3 c0.2,0.2,0.4,0.5,0.2,0.7L17.7,41C17.7,41.2,17.4,41.3,17.1,41.2z" />
        <circle className="srfront_st1" cx="13.8" cy="38.2" r="0.5" />
        <line className="srfront_st0" x1="15" y1="37.9" x2="14.1" y2="39.4" />
      </g>
      <path className="srfront_st0" d="M16.8,73.8l-0.2-3.6c1.6,2,3.9,2.9,4,3.2" />
      <path className="srfront_st0" d="M13.8,81.1l6.4-1.5c1.1-0.3,1.9-1.3,2-2.4l0.1-1.6" />
      <path className="srfront_st0" d="M5.8,62.2c0,0-1.5-14.3,2.6-12.5c0,0,4.7,2.3,7.9,18.7c0.8,3.6,0.5,6.7,0.1,8.7" />
      <path className="srfront_st0" d="M10.6,78.7C8.3,75.1,7.2,69,7.2,69l-1.1-1.1c0.2-0.8-0.2-6.3-0.5-8.4c0-0.3-0.2-0.8-0.2-1.1 c-1.1-5.9-0.9-9.3,0.1-10.8C5.7,47.3,6,44.8,6,44.5c0.5-2.6-1.3-5.6-1.3-5.6c0.3-5.7,4.1-16.1,5-17" />
      <ellipse transform="matrix(0.9891 -0.1474 0.1474 0.9891 -9.6199 2.3729)" className="srfront_st2" cx="11.2" cy="66.1" rx="3.6" ry="11.7" />
      <path className="srfront_st0" d="M8.5,50c0,0-3.6,8.2-1.3,19.2" />
      <ellipse transform="matrix(0.9918 -0.1279 0.1279 0.9918 -8.4669 1.9565)" className="srfront_st3" cx="11" cy="66.9" rx="1" ry="2.5" />
      <path className="srfront_st0" d="M16.5,76.7c-0.2,1.4-2.2,8.2-6.2,1.5" />
    </g>
  </svg>
);
export default SVGComponent;
